module.exports = __webpack_public_path__ + "static/fossil-5c609706b33b7e66ef47cd3cf57620ba.jpg";